import Vue from "vue"
import Router from "vue-router"
import Home from "@/views/Home.vue"

Vue.use(Router);

export const apiRoutes = {
  patientTriage: "v1/patient/triageAnonymous"
};

export const routes = [
  {
    path: "/",
    name: "home",
    meta: {index: 0},
    component: Home,
  },
  {
    path: "/privacy",
    name: "privacy",
    meta: {index: 1},
    component: () => import(/* webpackChunkName: "privacy" */ "@/views/Privacy.vue"),
  },
  {
    path: "/terms-and-conditions",
    name: "terms",
    meta: {index: 1},
    component: () => import(/* webpackChunkName: "terms" */ "@/views/Terms.vue"),
  },
  {
    path: "/step-1",
    name: "survey.step-1",
    meta: {index: 2},
    component: () => import(/* webpackChunkName: "survey.step-1" */ "@/views/Survey/Step1.vue"),
  },
  {
    path: "/step-2",
    name: "survey.step-2",
    meta: {index: 3},
    component: () => import(/* webpackChunkName: "survey.step-2" */ "@/views/Survey/Step2.vue"),
  },
  {
    path: "/step-3",
    name: "survey.step-3",
    meta: {index: 4},
    component: () => import(/* webpackChunkName: "survey.step-3" */ "@/views/Survey/Step3.vue"),
  },
  {
    path: "/step-4",
    name: "survey.step-4",
    meta: {index: 5},
    component: () => import(/* webpackChunkName: "survey.step-4" */ "@/views/Survey/Step4.vue"),
  },
  {
    path: "/complete",
    name: "appointment.not-needed",
    meta: {index: 6},
    component: () => import(/* webpackChunkName: "appointment.not-needed" */ "@/views/AppointmentNotNeeded.vue"),
  },
  {
    path: "/next-step",
    name: "appointment.needed",
    meta: {index: 6},
    component: () => import(/* webpackChunkName: "appointment.needed" */ "@/views/AppointmentNeeded.vue"),
  },
  {
    path: "/already-complete",
    name: "already.complete",
    meta: {index: 1},
    component: () => import(/* webpackChunkName: "already.complete" */ "@/views/CallAscenti.vue"),
  },
  {
    path: "*",
    name: "error.404",
    meta: {index: 0},
    component: () => import(/* webpackChunkName: "error.404" */ "@/views/PageNotFound.vue"),
  },
];

export default new Router({
  mode: "history",

  base: process.env.BASE_URL,

  routes,
})
